export enum imageType {
	desktop = 1,
	mobile = 2
}
